import React, { useState } from "react";
import * as commonData from "../../../Common";

function StatusCheckInput(props) {
  const [updatemanage, setUpdateManage] = useState({});
  const url = commonData.commonData().apiUrl;
  const checkedHandler = () => {
    let checked = event.target.checked;
    let colId = props.column.colId;
    props.node.setDataValue(colId, checked);
    setUpdateManage((prevState) => {
      return { ...prevState };
    });
  };
  if (props.colDef.field !== "status") {
    return (
      <input
        type="checkbox"
        className="form-check-input text-center mt-2"
        onClick={checkedHandler}
        checked={props.value}
      />
    );
  } else {
    return props.value;
  }
}

export default StatusCheckInput;
